import { DeleteAutomatedReportState, DeleteAutomatedReportActionTypes, DELETE_AUTOMATED_REPORT_REQUEST, DELETE_AUTOMATED_REPORT_SUCCESS, DELETE_AUTOMATED_REPORT_FAILURE } from "store/reducers/automated-report/delete-automated-report/types";

const defaultState: DeleteAutomatedReportState = {
  isLoading: false,
  errorMessage: ""
};

export default function deleteAutomatedReport(state = defaultState, action: DeleteAutomatedReportActionTypes): DeleteAutomatedReportState {
  switch (action.type) {
    case DELETE_AUTOMATED_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DELETE_AUTOMATED_REPORT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case DELETE_AUTOMATED_REPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};